import EmailRecipients from '../../components/card/email-recipients';
import { getMomentObjectInTimezone } from 'base/new-utils';
import PropTypes from 'prop-types';
import { useGlobalOutreachProvider } from '../../../contexts/global-outreach-context';
import { ActionsMenu, Icon } from '@evertrue/et-components';
import useFormatEmailBody from 'components/emailer/hooks/use-format-email-body';
import { useEmailThreads } from '../email-threads-context';
import { isEmpty } from '@evertrue/sdk';

const ThreadCardHeader = ({ email }) => {
  const { email_recipients } = email;
  const { openQuickInteraction } = useGlobalOutreachProvider();
  const { parseBodyForInteraction } = useFormatEmailBody();
  const { updateSent } = useEmailThreads();

  const filteredRecipients = email_recipients.filter((recipient) => recipient.recipient_type !== 'FROM');
  const primaryContacts = filteredRecipients.reduce((acc, { recipient_type, contact = {} }) => {
    if (recipient_type === 'TO' && !isEmpty(contact)) {
      return [...acc, contact];
    }
    return acc;
  }, []);

  const options = [];

  if (primaryContacts?.length > 0) {
    options.push({
      id: 1,
      icon: 'add',
      label: 'Add Interaction',
      onClick: () => {
        openQuickInteraction('emailer', {
          emailId: email.id,
          emailCreatorId: email.creator_user_id,
          updateSent,
          contact: primaryContacts?.[0],
          interaction: {
            summary: email.subject,
            text: `Sent the following email:\n${parseBodyForInteraction(email.body)}`,
          },
        });
      },
    });
  }

  return (
    <div className="email-card-body">
      <div className="email-card-body-left">
        <EmailRecipients recipients={email_recipients} />
        <h5>{email.subject}</h5>
      </div>
      <div className="email-card-body-right">
        {options?.length > 0 && (
          <ActionsMenu trigger={({ isOpen }) => <Icon icon="more-horiz" size={1} />} options={options} />
        )}
        <p>{getMomentObjectInTimezone(email.sent_at * 1000)?.format('MMM D, YYYY [at] h:mm A')}</p>
      </div>
    </div>
  );
};

ThreadCardHeader.propTypes = {
  email: PropTypes.object.isRequired,
};

export default ThreadCardHeader;
